import React from 'react';
import styled from 'styled-components';
import LogoWave from './LogoWave';
interface LoadingProps {
  isLoading: boolean;
}

const Loading: React.FC<LoadingProps> = ({ isLoading }) => {

  return (
    <LoadingOverlay $isVisible={isLoading}>
      <LogoWave size={'small'} />
    </LoadingOverlay>
  );
};

const LoadingOverlay = styled.div<{ $isVisible: boolean }>`
  width: 100%;
  height: 100%;
  background: rgba(235, 235, 235, 0.1);
  backdrop-filter: blur(2px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;

  // /* 불투명도와 트랜지션 */
  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
  transition: opacity 0.4s ease-in-out;

  pointer-events: ${({ $isVisible }) => ($isVisible ? 'auto' : 'none')};
`;


export default Loading;